import { useUser } from '@/app/providers';

export function useCurrentCompany() {
  const { user } = useUser();
  return {
    companyId: user?.companyUuid ?? null,
    isAssigned: user?.isCompanyAssigned ?? false,
  };
}
